// extracted by mini-css-extract-plugin
export default {"line":"horizontal-line_line__ubVb4"};